import { getDataByProvider } from '../../../jsCore/store/recommendedVideos/recommendedVideos.providers'
import { dispatch, getState } from '../../../jsCore/application/appStore'

export const RECEIVED_RECOMMENDATIONS_DATA = 'RECEIVED_RECOMMENDATIONS_DATA'
export const RECEIVED_RECOMMENDATIONS_DATA_ERROR = 'RECEIVED_RECOMMENDATIONS_DATA_ERROR'
export const SET_PLAYLIST = 'SET_PLAYLIST'

export function receivedRecommedationsAction(payload) {
  return {
    type: RECEIVED_RECOMMENDATIONS_DATA,
    payload: {
      ...payload,
      isInitialized: true,
      recievedError: false,
    },
  }
}

export function receivedErrorAction(payload) {
  return {
    type: RECEIVED_RECOMMENDATIONS_DATA_ERROR,
    payload: {
      isInitialized: false,
      recievedError: true,
    },
  }
}

export function setPlaylistId(playlist) {
  return {
    type: SET_PLAYLIST,
    payload: playlist,
  }
}

function payloadMapper(playerId, item) {
  item.hlink = `/videos/${playerId}/${item.mediaId}`
  return item
}

function normalizePayload(playerId, payload) {
  const recommendedItemsMapper = payloadMapper.bind(null, playerId)
  return {
    recommendedItems: payload.map(recommendedItemsMapper),
  }
}

function dispatchNormalizedVideoPaylaod(payload) {
  return dispatch(receivedRecommedationsAction(payload))
}

function dispatchReceivedError(payload) {
  return dispatch(receivedErrorAction(payload))
}

export function newVideoLoaded(providerName, playerId, videoId) {
  const normalizeVideoPayload = normalizePayload.bind(null, playerId)
  getDataByProvider({ providerName, playlistId: getState().recommendedVideos.playlistId, videoId })
    .then(normalizeVideoPayload)
    .then(dispatchNormalizedVideoPaylaod)
    .catch(dispatchReceivedError)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/recommendedVideos/recommendedVideos.actions.js